import { render, staticRenderFns } from "./SetPassword.vue?vue&type=template&id=2499b3f0&scoped=true"
import script from "./SetPassword.vue?vue&type=script&lang=ts"
export * from "./SetPassword.vue?vue&type=script&lang=ts"
import style0 from "./SetPassword.vue?vue&type=style&index=0&id=2499b3f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2499b3f0",
  null
  
)

export default component.exports